import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Trustedecommerceweb() {
  return (
    <section className="trusted_ecommerce_web p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Drive <span>Logistics Efficiency</span> with Advanced Tech
              Solutions
            </h2>
            <p>
              Accelerate your logistics operations with our custom-built
              software designed to solve industry challenges. We deliver
              scalable, secure, and fully integrated solutions to optimize your
              business.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={11} xxl={10} className="m-auto">
            <Row className="mt-3 mt-md-4">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#F8F8FB" }}
                >
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5 style={{ color: "#314252" }}>
                      Driver App with Real-Time Routing
                    </h5>
                    <p style={{ color: "#898989" }}>
                      Maximize fleet performance with live GPS tracking, route
                      optimization, task updates, and automated dispatching.
                      Streamline communication and reduce delivery times with
                      built-in navigation and alerts.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#F8F8FB" }}
                >
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5 style={{ color: "#314252" }}>
                      Intelligent Dispatcher Dashboard
                    </h5>
                    <p style={{ color: "#898989" }}>
                      Oversee your entire fleet with an intelligent dashboard
                      featuring automated route assignments, performance
                      tracking, and real-time data analysis to ensure smooth
                      logistics operations.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className="mb-md-0 mb-4"
              >
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#F8F8FB" }}
                >
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5 style={{ color: "#314252" }}>
                      Customer-Facing App with Live Tracking
                    </h5>
                    <p style={{ color: "#898989" }}>
                      Offer customers transparency with real-time tracking,
                      delivery notifications, and in-app messaging. Elevate the
                      customer experience with instant feedback, delivery
                      reviews, and scheduling flexibility.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#F8F8FB" }}
                >
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5 style={{ color: "#314252" }}>
                      Integrated Fleet Management System
                    </h5>
                    <p style={{ color: "#898989" }}>
                      Manage your fleet efficiently with vehicle tracking, fuel
                      usage reports, maintenance alerts, and driver performance
                      analytics, all from one central platform for complete
                      operational control.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Trustedecommerceweb;
